import { Component, EventEmitter, ViewChild, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { Dialog } from 'primeng/dialog';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import {
    DeclaracionSuplementariaItemResultsViewModel,
    TDeclaracionSuplementariaViewModel,
} from '../../../../../_mantenimiento/general/declaracionessuplementarias/declaracionsuplementaria.types';

@Component({
    selector: 'app-declaracion-adicional-popup',
    templateUrl: './declaracionAdicionalPopup.component.html',
})
export class DeclaracionAdicionalPopupComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<TDeclaracionSuplementariaViewModel>(); // emit para grid en modo selección doble clic en la fila a seleccionar
    @ViewChild('tableSearch') turboTable: Table;

    resultDeclaracionAdicional: DeclaracionSuplementariaItemResultsViewModel;
    display = false;
    cols: any[];

    selectedDeclaracionAdicional: TDeclaracionSuplementariaViewModel | null;
    DescripcionCampania: string;

    constructor(
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
    ) {
        super();
    }

    ngOnInit() {
        this.cols = [
            //{ field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdCampaniaDescripcion', header: 'Campaña' },
            { field: 'IdTipoTextoDecSuplementariaCamDescripcion', header: 'Tipo Declaración' },
            { field: 'DescripcionTexto', header: 'Texto' },
            { field: 'TextoDecSuplementaria', header: 'Declaración Adicional' },
            { field: 'Observaciones', header: 'Observaciones' },
        ];
    }

    //idGrupo: Para Informe de Importaciones
    showDialog(declaraciones: DeclaracionSuplementariaItemResultsViewModel, descripcionCampania: string): void {
        this.display = true;
        this.resultDeclaracionAdicional = declaraciones;
        this.DescripcionCampania = descripcionCampania;
    }

    //emit para grid en modo selección doble clic en la fila a seleccionar
    onRowDblClick(event: any, declaracionAdicional: TDeclaracionSuplementariaViewModel): void {
        this.display = false;
        this.searchingButton = false;
        this.selectedDeclaracionAdicional = declaracionAdicional;
        this.selected.emit(this.selectedDeclaracionAdicional);
    }

    acceptDialog(): void {
        this.display = false;
        this.selected.emit(this.selectedDeclaracionAdicional!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect(selection: TDeclaracionSuplementariaViewModel): void {
        this.selectedDeclaracionAdicional = selection;
    }

    noAccepted(): boolean {
        return !this.selectedDeclaracionAdicional;
    }
}
